import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller, useNa } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import EditIcon from '@mui/icons-material/Edit';
import { Switch, TextareaAutosize } from '@mui/material';
import {
    BrowserRouter as Router,
    useParams,
} from 'react-router-dom';
import dateFormats from '../../services/dateFormats';
import HolidaysHistory from './HolidaysHistory';

export default function EditHoliday() {
    const [employees, setEmployees] = useState([]);
    let { id } = useParams();
    const alert = { open: false, message: '', variant: '' };
    const [toast, setToast] = useState(alert);
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        //resolver: yupResolver(validationSchema),
    });
    const holidayTypes = [{ id: 0, name: "" }, { id: 1, name: "Vjetor" }, { id: 2, name: "Mjekësor" }, { id: 3, name: "Martesor" }, , { id: 4, name: "Pa pagesë" }, { id: 5, name: "Jashtëzakonshëm" }]

    const toLowerKeys = (obj) => {
        return Object.keys(obj).reduce((accumulator, key) => {
            key = accumulator[key.charAt(0).toLowerCase() + key.slice(1, -1) + key.slice(-1).toLocaleLowerCase()] = obj[key];
            return accumulator;
        }, {});
    }

    const getEHoliday = (employees) => {
        apiService()
            .query('getHoliday', 'id=' + id)
            .then((response) => {
                if (response.success) {
                    response.data[0].StartDate = dateFormats(response.data[0].StartDate);
                    response.data[0].EndDate = dateFormats(response.data[0].EndDate);
                    const fields = Object.keys(response.data[0]);
                    fields.map((field) => {
                        if (field === "Employee") {
                            setValue("EmployeeId", response.data[0][field]);
                            setValue(
                                'Employee',
                                employees.find(function (e) {
                                    return e.Id === response.data[0].Employee;
                                })
                            );
                        }
                        else if (field === "HolidayType") {
                            setValue(
                                'HolidayType',
                                holidayTypes.find(function (e) {
                                    return e?.id === response.data[0].HolidayType;
                                })
                            );
                        }
                        else {
                            setValue(field, response.data[0][field]);
                        }

                    });
                }
            });
    }

    const getEmployees = () => {
        apiService()
            .get('workers')
            .then((response) => {
                if (response.success) {
                    setEmployees(response.data);
                    getEHoliday(response.data);
                }
            });
    }


    useEffect(() => {
        getEmployees();
    }, []);

    const onSubmit = (data) => {
        data.Approve = data.Approve ? data.Approve : false;
        data.Employee = data.Employee.Id;
        data.HolidayType = data.HolidayType.id;
        data.CreatedBy = "";

        console.log(data)
        apiService()
            .put('holidays', data)
            .then((response) => {
                console.log(response)
                if (response.success) {
                    setToast({
                        open: true,
                        message: 'U ruajten me sukses!',
                        variant: 'success',
                    });
                } else {
                    setToast({
                        open: true,
                        message: 'Ka ndodhur nje gabim!',
                        variant: 'error',
                    });
                }
            });
    };


    return (
        <div className="">
            <Fragment>
                <Toast {...toast} />
                <TopActions
                    newHref="/holidays/addholiday"
                    save={handleSubmit(onSubmit)}
                />

                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Personal Data
                        </Typography>
                        <form>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <SelectController
                                        placeholder="LLoji i pushimit"
                                        error={errors.HolidayType}
                                        control={control}
                                        options={holidayTypes}
                                        name="HolidayType"
                                        register={{ ...register('HolidayType') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <SelectController
                                        placeholder="Punëtori"
                                        error={errors.Employee}
                                        control={control}
                                        options={employees}
                                        name="Employee"
                                        register={{ ...register('Employee') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Data e fillimit"
                                        error={errors.StartDate}
                                        control={control}
                                        type="date"
                                        register={{ ...register('StartDate') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} lg={3}>
                                    <InputController
                                        placeholder="Data e mbarimit"
                                        error={errors.EndDate}
                                        control={control}
                                        type="date"
                                        register={{ ...register('EndDate') }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={1} lg={1}>
                                    <FormControlLabel
                                        control={<Switch
                                            error={errors.Approve}
                                            control={control}
                                            name="Approve"
                                            register={{ ...register('Approve') }}
                                            onChange={(e) => setValue("Approve", e.target.checked ? e.target.checked : false)}
                                            checked={watch("Approve")}
                                            defaultChecked={false}
                                        />}
                                        label="Aprovimi"
                                    />
                                </Grid>
                            </Grid>
                            <Grid item spacing={4} style={{ marginTop: 20 }}>
                                <TextareaAutosize
                                    className='custom-textarea'
                                    placeholder="Komenti"
                                    error={errors.Description}
                                    control={control}
                                    type="textarea"
                                    register={{ ...register('Description') }}
                                    value={watch('Description')}
                                    style={{ width: '100%' }}
                                    minRows={5}
                                    name="Description"
                                    defaultValue=""
                                    onChange={(e) => setValue('Description', e.target.value)}
                                />
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
                {watch("EmployeeId") && <HolidaysHistory id={watch("EmployeeId")} filter={true} />}
            </Fragment>
        </div>
    );
}
